import { render, staticRenderFns } from "./DM_transactionHideAdd.vue?vue&type=template&id=87d3d16e&scoped=true&"
import script from "./DM_transactionHideAdd.vue?vue&type=script&lang=js&"
export * from "./DM_transactionHideAdd.vue?vue&type=script&lang=js&"
import style0 from "./DM_transactionHideAdd.vue?vue&type=style&index=0&id=87d3d16e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d3d16e",
  null
  
)

export default component.exports